export const RecType = Object.freeze({
  Approved: "approved",
  Pending: "pending",
  Queried: "queried",
  Printed: "printed",
  Unprinted:"unprinted"
});
